module.exports = __webpack_public_path__ + "img/qrcode.ffd8c7d9.jpg";